const content = {
  title: "Present Perfect vs Past Simple",
  explanation: `
Both Present Perfect and Past Simple refer to the past, but they organize time differently.
Example: I have finished my report. / I finished my report yesterday.

Use Present Perfect when the exact time is unknown or not important, and the present result matters.
Example: She has lost her keys. (She cannot open the door now.)

Use Past Simple when the action happened at a finished time in the past.
Example: She lost her keys last night.

At B1 level, always ask: "Do I mean life experience/result now, or a finished past moment?"
Example: Have you ever visited Rome? / I visited Rome in 2021.
  `,
  rules: [
    "Present Perfect: have / has + past participle",
    "Use Present Perfect when the time is not mentioned or not important",
    "Past Simple: verb in past form (V2 or irregular)",
    "Use Past Simple when the action happened at a finished time",
    "Finished time expressions: yesterday, last week, last year, in 2020"
  ],
  examples: [
    "I have visited Paris. (experience, no time mentioned)",
    "I visited Paris in 2019. (finished time)",
    "She has lost her keys. (the result is important now)",
    "She lost her keys yesterday. (finished past action)",
    "Have you ever seen this movie?"
  ]
};

export default content;


